import { Typography, Select, InputLabel } from "@mui/material";
import { Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from "@mui/material"
import { Box, FormControl, OutlinedInput, MenuItem } from "@mui/material";
import { AppLayout } from "../../../layouts/app";
import { useContext, useEffect, useState } from "react";
import { BreadcrumbContext } from "../../../contexts/breadcrumb";
import { Link } from "react-router-dom";
import { TrackersService } from "../../../services/trackers";
import { CompaniesService } from "../../../services/companies";
import { VehiclesService } from "../../../services/vehicles";
import { TrackerRelationshipsService } from "../../../services/trackerRelationships";
import { CrudLayout } from "../../../layouts/crud";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import { DataGridTracker } from "../../../components/dataGridTracker";
import { Modal } from "../../../components/modal"
import { TextField } from '@mui/material';
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { Button } from "antd";
import { SendOutlined, HistoryOutlined } from "@ant-design/icons";
import BroadcastOnHomeIcon from '@mui/icons-material/BroadcastOnHome';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

const columns = [
    {
        field: 'deviceId',
        headerName: 'ID Dispositivo',
        width: 150,
        editable: false,
        headerAlign: "center",
        align: "center",
    },
    {
        field: 'createdAt',
        headerName: 'Data de Criação',
        type: 'dateTime',
        valueFormatter: params => moment(params?.value).format("DD/MM/YYYY HH:mm:ss"),
        width: 180,
        editable: false,
        headerAlign: "center",
        align: "center",
    },
    {
        field: 'companyName',
        headerName: 'Empresa',
        width: 250,
        editable: false,
        headerAlign: "center",
        align: "center",
    },
    {
        field: 'vehiclePlate',
        headerName: 'Veículo Associado',
        width: 250,
        editable: false,
        headerAlign: "center",
        align: "center",
    },

];


export const Trackers = () => {
    const [breadcrumbs, setBreadcrumbs] = useContext(BreadcrumbContext);
    const [trackers, setTrackers] = useState([]);
    const [cmdResponse, setCmdResponse] = useState("");
    const [paramResponse, setParamResponse] = useState("");
    const [loadingData, setLoadingData] = useState(true);
    const [openLinkDialog, setOpenLinkDialog] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [currentTrackerId, setCurrentTrackerId] = useState("");
    const [trackerID, setTrackerId] = useState("");
    const [selectedCompanyId, setSelectedCompanyId] = useState("");
    const [selectedVehicleId, setSelectedVehicleId] = useState("");
    const [selectedCommand, setSelectedCommand] = useState("");
    const [openUnlinkDialog, setOpenUnlinkDialog] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const trackersService = new TrackersService();
    const companiesService = new CompaniesService();
    const vehiclesService = new VehiclesService();
    const trackerRelationshipService = new TrackerRelationshipsService();
    const [sendCommandTrackerDialogOpen, setSendCommandTrackerDialogOpen] = useState(false);
    const [updateTrackerDialogOpen, setUpdateTrackerDialogOpen] = useState(false);
    const [selectedTracker, setSelectedTracker] = useState('');
    const [inputValue, setInputValue] = useState("");
    const [inputID, setInputID] = useState("");
    const [inputHintText, setHintText] = useState("");
    const [textFieldDisable, setTextFieldDisable] = useState(false);
    const [commandSend, setCommandSend] = useState("");
    const [selectedRows, setSelectedRows] = useState([]);
    const [files, setFiles] = useState([]);
    const [openModalHistoryCommands, setOpenModalHistoryCommands] = useState(false);
    const [openModalDevicesCommands, setOpenModalDevicesCommands] = useState(false);
    const [allCommandsParam, setAllCommandsParam] = useState([]);
    const [allCommands, setAllCommands] = useState([]);
    const [listCommandsParam, setListCommandsParam] = useState([]);
    const [listCommands, setListCommands] = useState([]);
    const [openSnackBar, setSnackBar] = useState(false);
    const [headerTracker, setHeaderTracker] = useState("");
    const [openBroadcastCommands, setOpenBroadcastCommands] = useState(false);
    const [inputValueBroadcast, setInputValueBroadcast] = useState("");

    const columnsHistoryCommands = [
        {
            field: 'actions',
            type: 'actions',
            headerName: '',
            cellClassName: 'actions',
            width: 80,
            editable: false,
            headerAlign: 'center',
            align: 'center',
            getActions: (params) => {
                const status = params.row.status;
                if (status === 6 || status === 7 || status === 10) {
                    return [
                        <GridActionsCellItem
                            title={"Concluído"}
                            icon={<CheckRoundedIcon />}
                            label="Concluído"
                            color="inherit"
                            sx={{ color: 'green', ':hover': { backgroundColor: 'rgba(223, 250, 219, 0)' }, pointerEvents: 'none' }}
                        />
                    ];
                }
                return [
                    <GridActionsCellItem
                        title={"Deletar"}
                        icon={<DeleteRoundedIcon />}
                        label="Deletar"
                        onClick={() => handleDeleteCommand(params.id)}
                        color="inherit"
                        sx={{ color: 'red', ':hover': { backgroundColor: 'rgb(250, 219, 219, 0.8)' } }}
                    />
                ];
            },
        },
        {
            field: 'action',
            headerName: 'Deletar Comando',
            width: 150,
            editable: false,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'deviceId',
            headerName: 'ID Dispositivo',
            width: 150,
            editable: false,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'realCreatedAt',
            headerName: 'Data de Criação',
            type: 'dateTime',
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY HH:mm:ss"),
            width: 180,
            editable: false,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'status',
            headerName: 'Status',
            valueFormatter: ((params) => {
                if (params.value === 0) {
                    return "Comando salvo no banco de dados."
                } else if (params.value === 2) {
                    return "Comando enviado."
                } else if (params.value === 6) {
                    return "Resposta do rastreador."
                } else if (params.value === 7) {
                    return "Resposta do módulo."
                } else if (params.value === 8) {
                    return "Reenviado após 5 minutos."
                } else if (params.value === 9) {
                    return "Resposta do rastreador após 5 minutos."
                } else if (params.value === 3) {
                    return "Reenviado após 5 minutos."
                } else if (params.value === 10) {
                    return "Resposta ao preset do módulo."
                }
            }),
            width: 250,
            editable: false,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'setCommand',
            headerName: 'Comando Enviado',
            width: 500,
            editable: false,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'suntechResponse',
            headerName: 'Resposta do Commando',
            width: 3500,
            editable: false,
            valueGetter: (params) => params.row.suntechResponse || '',
            headerAlign: "center",
            align: "center",
        },


    ];

    /**
     * Load that when the component is rendered
     */
    useEffect(() => {
        const breadcrumbs = [
            <Link key="1" to="/">
                Home
            </Link>,
            <Typography key="3" color="text.primary">
                Comandos
            </Typography>
        ];
        companiesService.getCompanies()
            .then((response) => {
                setCompanies(response.data);
            })
            .catch((error) => {
            });
        getVehicles();
        setBreadcrumbs(breadcrumbs);
        getTrackersData();
    }, []);


    /**
     * Update Vehicles list
     */
    const getVehicles = () => {
        vehiclesService.getNoLinked()
            .then((response) => {
                setVehicles(response.data);
            })
            .catch((error) => {
            });
    };

    /**
     * Get Trackers to show in table
     */
    const getTrackersData = () => {
        trackersService.getTrackersAdminVm().then(res => {
            setTrackers(res.data);
            setLoadingData(false);
        }).catch(err => {
            setLoadingData(false);
        });
    }

    function requestLoop() {
        const interval = 5000;
        trackersService.getTrackerCMD(trackerID).then((res) => {
            if (res.data.suntechResponse == null) {
                setTimeout(requestLoop, interval);
            } else {
                setCmdResponse(res.data.suntechResponse);
            }
        }).catch((error) => {
        })
    }

    const getResponseCMD = (trackerID) => {
        requestLoop();
    }

    const getResponseParam = (trackerID, command) => {
        const interval = 10000;
        function requestLoop() {
            trackersService.getResponseParam(trackerID, command).then((res) => {
                if (res.data.suntechResponse == null) {
                    setTimeout(requestLoop, interval);
                } else {

                    const responseCommand = res.data.suntechResponse.split(";");
                    if (trackerID.toString() === responseCommand[1].toString()) {
                        setParamResponse(res.data.suntechResponse);
                    }
                }

            }).catch((error) => {
            })
        }
        requestLoop();
    }

    /**
     * Delete a specific tracker.
     * @param {id} Tracker Id
     */
    const handleDelete = (id) => {
        if (trackers.find(t => t.id === id).companyId !== '00000000-0000-0000-0000-000000000000') {
            NotificationManager.error('Rastreador está associado e não pode ser excluído.', "", 3000);
            return;
        }
        setCurrentTrackerId(id);
        setOpenDeleteDialog(true);
    }

    /**
     * Handle cancel Delete Dialog
     */
    const handleDeleteDialogCancel = () => {
        setOpenDeleteDialog(false);
    }

    /**
     * User answer yes and the register will be deleted.
     */
    const handleDeleteDialogYes = () => {
        trackersService.deleteTracker(currentTrackerId).then(res => {
            if (res.status === 200) {
                NotificationManager.success('Registro removido.', "", 3000);
            }
            getTrackersData();
        }).catch(err => {
            NotificationManager.error('Erro ao remover registro.', "", 3000);
        });
        setOpenDeleteDialog(false);
    }

    /**
     * Open Dialog where the user can choose company and vehicle to tracker.
     * @param {*} Tracker id 
     */
    const handleLinkClick = (id) => {
        if (trackers.find(t => t.id === id).companyId !== '00000000-0000-0000-0000-000000000000') {
            NotificationManager.error('Rastreador já associado.', "", 3000);
            return;
        }
        setCurrentTrackerId(id);
        setOpenLinkDialog(true);
    }

    /**
     * Handle unlink, so remove tracker association with vehicle and company
     * @param {*} Tracker Id 
     */
    const handleUnlinkClick = (id) => {
        if (trackers.find(t => t.id === id).companyId === '00000000-0000-0000-0000-000000000000') {
            NotificationManager.error('Rastreador não associado.', "", 3000);
            return;
        }
        setCurrentTrackerId(id);
        setOpenUnlinkDialog(true);
    }

    /**
     * Close link dialog without save data
     */
    const handleCancelDialog = () => {
        setSelectedCompanyId("");
        setOpenLinkDialog(false);
    }

    /**
     * Set the new Company set by select change event
     * @param {*} Select change event 
     */
    const handleCompanyChanged = (evt) => {
        setSelectedCompanyId(evt.target.value);
    }

    /**
     * Set the selected vehicle.
     * @param {*} Vehicle selected change event
     */
    const handleVehicleChanged = (evt) => {
        setSelectedVehicleId(evt.target.value);
    }

    /**
     * Save the relationship
     */
    const handleSaveRelationship = (e) => {
        var trackerRelationship = {
            "vehicleId": selectedVehicleId,
            "trackerId": currentTrackerId,
            "companyId": selectedCompanyId
        };

        e.preventDefault();
        trackerRelationshipService.postTrackerRelationship(trackerRelationship)
            .then((response) => {
                getTrackersData();
                NotificationManager.success('Associação salva.', "", 3000);
                setOpenLinkDialog(false);
            })
            .catch((error) => {
                NotificationManager.error('Erro ao salvar associação entre rastreador e veículo.', "", 3000);
                setOpenLinkDialog(false);
            });
        getVehicles();
    }

    /**
     * User decided do not delete the register, just close the dialog.
     */
    const handleDeleteConfirmNo = () => {
        setOpenUnlinkDialog(false);
    }

    /**
     * User Confirm the unlink 
     */
    const handleDeleteConfirmYes = () => {
        trackerRelationshipService.postUnlinkTrackerRelationship(currentTrackerId)
            .then((response) => {
                NotificationManager.success('Associação excluída.', "", 3000);
                getTrackersData();
                setOpenUnlinkDialog(false);
                setSnackBar(true);
            })
            .catch((error) => {
                console.error(error);
                NotificationManager.error('Erro ao remover associação entre rastreador e veículo.', "", 3000);
                setOpenUnlinkDialog(false);
            });
        getVehicles();
    }

    const handleSendCommandTrackerClose = () => {
        setTrackerId("");
        setSendCommandTrackerDialogOpen(false);
        setUpdateTrackerDialogOpen(false);
        const getTimeoutResponseCommand = sessionStorage.getItem("timeoutResponseCommand");
        clearTimeout(getTimeoutResponseCommand);
    }

    const handleOpenModalHistoryCommand = () => {
        setOpenModalHistoryCommands(true);
        getAllCommands();
    }

    const getAllCommands = async () => {
        try {
            var response = await trackersService.getAllCommandsParam(trackerID);
            var response2 = await trackersService.getAllCommands(trackerID);
            if (response.status === 200) {
                setAllCommandsParam(response.data);
            }
            if (response2.status === 200) {
                setAllCommands([...response2.data]);
            }
        }
        catch (error) {
            console.error("Error ao carregar comandos", error);
        }
    }

    const handleGetCommands = async () => {

        try {
            var response = await trackersService.getListCommandsParam(selectedRows);
            setListCommandsParam(response.data);
        }
        catch (error) {
            console.error(error);
        }
    }

    const handleOpenModalDevicesCommands = () => {
        setOpenModalDevicesCommands(true);
        handleGetCommands();
    }


    const handleClosedModalHistoryCommand = () => {
        setOpenModalHistoryCommands(false);
    }

    const commandsForDisplay = [
        { id: 3, name: "Comando para módulo", hint: ``, disable: false },
        { id: 19, name: "Comando para rastreador", hint: ``, disable: false },
        { id: 8, name: "Requesting Status", context: `ST300CMD;${trackerID};02;StatusReq`, disable: true },
        { id: 9, name: "Pre-setting A", context: `ST300CMD;${trackerID};02;PresetA`, disable: true },
        { id: 10, name: "Pre-setting", context: `ST300CMD;${trackerID};02;Preset`, disable: true },
        { id: 11, name: "ACK of Emergency", context: `ST300CMD;${trackerID};02;AckEmerg`, disable: true },
        { id: 12, name: "Enable1 (‘Activating Output 1’)", context: `ST300CMD;${trackerID};02;Enable1`, disable: true },
        { id: 13, name: "Disable1 (‘Inactivating Output1’)", context: `ST300CMD;${trackerID};02;Disable1`, disable: true },
        { id: 14, name: "Enable2 (‘Activating Output 2’)", context: `ST300CMD;${trackerID};02;Enable2`, disable: true },
        { id: 15, name: "Disable2 (‘Inactivating Output2’)", context: `ST300CMD;${trackerID};02;Disable2`, disable: true },
        { id: 16, name: "Requesting IMSI", context: `ST300CMD;${trackerID};02;ReqIMSI`, disable: true },
        { id: 17, name: "Requesting ICCID", context: `ST300CMD;${trackerID};02;ReqICCID`, disable: true },
        { id: 18, name: "Requesting Version", context: `ST300CMD;${trackerID};02;ReqVer`, disable: true },
    ];

    const commandsForDisplayUEX = [
        { id: 3, name: "Comando para módulo", hint: ``, disable: false },
        { id: 19, name: "Comando para rastreador", hint: ``, disable: false },
        { id: 8, name: "Requesting Status", context: `CMD;${trackerID};03;01`, disable: true },
        { id: 9, name: "Pre-setting ", context: `CMD;${trackerID};03;05`, disable: true },
        { id: 10, name: "Pre-setting P", context: `CMD;${trackerID};03;05;`, disable: false },
        { id: 11, name: "Get Emergency Mode", context: `CMD;${trackerID};02;05`, disable: true },
        { id: 12, name: "Set Emergency Mode", context: `CMD;${trackerID};02;05;`, disable: false },
        { id: 16, name: "Requesting IMSI", context: `CMD;${trackerID};01;02`, disable: true },
        { id: 17, name: "Requesting ICCID", context: `CMD;${trackerID};01;03`, disable: true },
        { id: 18, name: "Requesting Version", context: `CMD;${trackerID};03;04;`, disable: false },

    ];

    const handleInputChange = (evt) => {
        setInputValue(evt.target.value);
    }

    const handleInputChangeBroadcast = (evt) => {
        setInputValueBroadcast(evt.target.value);
    }

    const handleSendCommandTrackerOpen = (id) => {

        const tracker = trackers.find((t) => t.id === id);
        setSendCommandTrackerDialogOpen(true);
        setCurrentTrackerId(id);
        setTrackerId(tracker.deviceId);
        setHeaderTracker(tracker.header);
        setInputValue("");
        setSelectedCommand("");
        setCmdResponse("");
        setCommandSend("");
        setParamResponse("");
    }

    const handleSelectedCommand = (evt) => {
        const selectedValue = JSON.parse(evt.target.value);
        setSelectedCommand(selectedValue.value);
        if (selectedValue.value == null) {
            setInputValue("");
        } else {
            setInputValue(selectedValue.value);
        }
        setInputID(selectedValue.id);
        setHintText(selectedValue.hintText);
        setTextFieldDisable(selectedValue.disable);
    }

    const startRequestLoopCommand = () => {
        getResponseCMD(trackerID);
    }

    const startRequestLoopCommandDex = (command) => {
        getResponseParam(trackerID, command);
    }

    const handleSave = (currentTrackerId, trackerID, inputValue, inputID, headerTracker) => {

        setInputValue("");
        setSelectedCommand("");
        setCmdResponse("");
        setCommandSend("");
        setParamResponse("");
        var newCommand;
        if (inputValue !== "" && headerTracker === "ST300UEX") {

            if (inputID === 1) {
                newCommand = "ST300DEX;" + trackerID + ";02;" + (inputValue.length + 8 + 4 + 2) + ";CMD,5," + inputValue + ",";
                setCommandSend(newCommand);
            } else if (inputID === 3) {
                if (inputValue.endsWith(',')) {
                    newCommand = "ST300DEX;" + trackerID + ";02;" + (inputValue.length + 6) + ";" + inputValue;
                    setCommandSend(newCommand);
                } else {
                    newCommand = "ST300DEX;" + trackerID + ";02;" + (inputValue.length + 7) + ";" + inputValue;
                    setCommandSend(newCommand);
                }

            } else if (inputID === 2) {
                newCommand = "ST300DEX;" + trackerID + ";02;" + (inputValue.length + 8 + 4 + 2) + ";CMD,6,0,";
                setCommandSend(newCommand);
            } else if (inputID === 4) {
                newCommand = "ST300DEX;" + trackerID + ";02;" + (inputValue.length + 8 + 4 + 2) + ";CMD,1,0,";
                setCommandSend(newCommand);
            } else if (inputID === 5) {
                newCommand = "ST300DEX;" + trackerID + ";02;" + (inputValue.length + 8 + 4 + 2) + ";CMD,2,0,";
                setCommandSend(newCommand);
            } else if (inputID === 6) {
                newCommand = "ST300DEX;" + trackerID + ";02;" + (inputValue.length + 8 + 4 + 2) + ";CMD,3,0,";
                setCommandSend(newCommand);
            } else if (inputID === 7) {
                newCommand = "ST300DEX;" + trackerID + ";02;" + (inputValue.length + 8 + 4 + 2) + ";CMD,4,0,";
                setCommandSend(newCommand);
            } else {
                setCommandSend(inputValue);
                newCommand = inputValue.replace(trackerID, currentTrackerId);
            }
            trackersService.uploadCmd(newCommand)
                .then((response) => {
                    NotificationManager.success('Comando enviado com Sucesso!', "", 3000);
                })
                .catch((error) => {
                });

        } else if (inputValue !== "" && headerTracker === "UEX") {

            if (inputValue !== "" && inputID === 3) {
                newCommand = "DEX;" + trackerID + ";" + "00" + (!inputValue.endsWith(',') ? inputValue.length + 4 + 2 + 1 : inputValue.length + 4 + 2) + ";" + inputValue;
                setCommandSend(newCommand);
                trackersService.uploadCmd(newCommand).then((response) => {
                    NotificationManager.success('Comando enviado com Sucesso!', "", 3000);
                })
                    .catch((error) => {
                    });

            } else {
                setCommandSend(inputValue);
                newCommand = inputValue.replace(trackerID, currentTrackerId);
                trackersService.uploadCmd(newCommand)
                    .then((response) => {
                        NotificationManager.success('Comando enviado com Sucesso!', "", 3000);
                    })
                    .catch((error) => {
                    });

            }

        }

        const header = newCommand.split(";")
        if (header[0] === "ST300DEX" || header[0] === "DEX") {
            const timeoutId = setTimeout(() => {
                startRequestLoopCommandDex(newCommand);
            }, 10000);
            sessionStorage.setItem("timeoutResponseCommand", timeoutId)
        } else {
            setTimeout(startRequestLoopCommand, 10000);
        }
    }

    const handleSelectedDevices = (devicesId) => {
        setSelectedRows(devicesId);
    }

    const handleSaveCommandsBroadcast = () => {
        const broadcast = {
            "devicesId": selectedRows,
            "command": inputValueBroadcast
        }

        if (inputValueBroadcast.startsWith("$")) {
            trackersService.sendBroadcastCommand(broadcast)
                .then((response) => {
                    NotificationManager.success('Comando enviado com Sucesso!', "", 3000);
                    setInputValueBroadcast("");
                })
                .catch((error) => {
                    console.error(error);
                    NotificationManager.error('Erro ao enviar comando.', "", 3000);
                });
        } else {
            NotificationManager.warning('O comando informado não faz parte do protocolo definido para os módulos.', "", 3000);
        }


    }

    const concatenatedArray = allCommands.concat(allCommandsParam);
    const listConcatenatedArray = listCommands.concat(listCommandsParam);

    const sortedHistoryCommands = listConcatenatedArray.sort((a, b) => {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);

        if (dateA > dateB) {
            return -1;
        } else if (dateA < dateB) {
            return 1;
        } else {
            return 0;
        }
    });

    const sortedArray = concatenatedArray.sort((a, b) => {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);

        if (dateA > dateB) {
            return -1;
        } else if (dateA < dateB) {
            return 1;
        } else {
            return 0;
        }
    });

    const handleDeleteCommand = async (id) => {
        try {
            if (id !== null) {
                const response = await trackersService.deleteCommandById(id);
                if (response.status === 200) {
                    getAllCommands();
                    NotificationManager.success("Comando deletado com sucesso!", "", 3000);
                }
            }
        }
        catch (error) {
            console.error("Error ao deletar comando", error);
            NotificationManager.error("Error ao deletar comando!", "", 3000);
        }
    }

    return (
        <>
            <AppLayout>
                <CrudLayout
                    title={
                        <>
                            Rastreadores
                        </>
                    }
                    newRecordLink="/trackers/add"
                    children={
                        <>
                            <DataGridTracker
                                columns={columns}
                                editMode="row"
                                data={trackers.filter((tracker) =>
                                    tracker.deviceId.toString().includes(selectedTracker)
                                )}
                                loadingData={loadingData}
                                deleteRecord={handleDelete}
                                linkRecord={handleLinkClick}
                                unLinkRecord={handleUnlinkClick}
                                sendCommandTrackerDialogOpen={handleSendCommandTrackerOpen}
                                files={files}
                                devicesId={handleSelectedDevices}

                            />
                            {selectedRows.length > 1 && (
                                <Button
                                    type="primary"
                                    style={{ background: "#008000", color: "white", float: "right", marginTop: "10px", marginRight: "10px" }}
                                    onClick={() => setOpenBroadcastCommands(true)}
                                    icon={<BroadcastOnHomeIcon />}
                                    size='middle'
                                >
                                    Disseminar Comandos
                                </Button>
                            )}
                        </>
                    }
                />

                <Dialog open={openLinkDialog}>
                    <DialogTitle>Associar Rastreador</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Escolha a empresa e o veículo onde o rastreador está instalado:
                        </DialogContentText>
                        <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
                            <FormControl sx={{ m: 1, minWidth: 250 }}>
                                <InputLabel htmlFor="empresa-select-id">Empresa</InputLabel>
                                <Select
                                    onChange={handleCompanyChanged}
                                    input={<OutlinedInput label="Empresa" id="empresa-select-id" />}>
                                    {companies.map((company) => (
                                        <MenuItem key={company.id} value={company.id}>
                                            {company.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl sx={{ m: 1, minWidth: 250 }}>
                                <InputLabel htmlFor="veiculo-select-id">Veículo</InputLabel>
                                <Select
                                    onChange={handleVehicleChanged}
                                    input={<OutlinedInput label="Veículo" id="veiculo-select-id" />}>
                                    {vehicles.map((vehicle) => {
                                        if (selectedCompanyId != "") {
                                            if (selectedCompanyId == vehicle.companyId) {
                                                return <MenuItem key={vehicle.id} value={vehicle.id} >
                                                    {vehicle.plate}
                                                </MenuItem>
                                            }
                                        } else {
                                            return <MenuItem key={vehicle.id} value={vehicle.id} >
                                                {vehicle.plate}
                                            </MenuItem>
                                        }

                                    }

                                    )}
                                </Select>
                            </FormControl>
                        </Box>
                        <DialogActions>
                            <Button type="primary" style={{ background: "#008000", color: "white" }} onClick={(e) => handleSaveRelationship(e)}>Salvar</Button>
                            <Button type="primary" style={{ background: "#D21717", color: "white" }} onClick={handleCancelDialog}>Cancelar</Button>
                        </DialogActions>
                    </DialogContent>
                </Dialog>
                <Dialog open={openUnlinkDialog}>
                    <DialogTitle>Excluir Associação</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Deseja realmente excluir a associação do rastreador?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button type="primary" style={{ background: "#008000", color: "white" }} onClick={handleDeleteConfirmYes}>Sim</Button>
                        <Button type="primary" style={{ background: "#D21717", color: "white" }} onClick={handleDeleteConfirmNo}>Não</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={openDeleteDialog}>
                    <DialogTitle>Excluir Rastreador</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Deseja realmente excluir o rastreador?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button type="primary" style={{ background: "#008000", color: "white" }} onClick={handleDeleteDialogYes}>Sim</Button>
                        <Button type="primary" style={{ background: "#D21717", color: "white" }} onClick={handleDeleteDialogCancel}>Não</Button>
                    </DialogActions>
                </Dialog>
            </AppLayout>

            <Modal showBackArrow open={sendCommandTrackerDialogOpen} onClose={handleSendCommandTrackerClose} title={`Atualizar Rastreador ${headerTracker} ${trackerID}`} height={750} width={"80%"}>
                <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
                    <FormControl sx={{ m: 1, minWidth: 350 }}>
                        <InputLabel >Comandos Pré-Definidos</InputLabel>
                        <Select onChange={handleSelectedCommand}>

                            {

                                headerTracker === "UEX" ?

                                    commandsForDisplayUEX.map((command) => (
                                        <MenuItem key={command.id} value={JSON.stringify({ value: command.context, id: command.id, hintText: command.hint, disable: command.disable })}>
                                            {command.name}
                                        </MenuItem>))
                                    :
                                    commandsForDisplay.map((command) => (
                                        <MenuItem key={command.id} value={JSON.stringify({ value: command.context, id: command.id, hintText: command.hint, disable: command.disable })}>
                                            {command.name}
                                        </MenuItem>))

                            }

                        </Select>
                    </FormControl>
                    <Button icon={<SendOutlined />} size="large" iconPosition={"end"} style={{ marginTop: "15px", marginLeft: "100px", background: "#008000", color: "white" }} onClick={async () => {
                        handleSave(currentTrackerId, trackerID, inputValue, inputID, headerTracker);
                        await new Promise((resolve) => setTimeout(resolve, 100));
                        setInputValue("");
                        setSelectedCommand("");
                    }
                    }>Enviar Comando</Button>
                    <TextField
                        disabled={textFieldDisable}
                        label={inputHintText}
                        value={inputValue}
                        onChange={handleInputChange}
                        sx={{ width: '100%', marginTop: '10px' }}
                    />
                </Box>
                <Typography sx={{ marginTop: "10px", wordWrap: 'break-word' }} variant="subtitle1">
                </Typography>
                <Typography sx={{ marginTop: "15px", wordWrap: 'break-word', color: 'black' }}>
                    <div>
                        Comando: {commandSend}
                    </div>
                </Typography>

                <Typography sx={{ marginTop: "15px", wordWrap: 'break-word', color: 'black' }}>
                    <div>
                        Resposta: {cmdResponse !== "" ? cmdResponse : paramResponse !== "" ? paramResponse : ""}

                    </div>
                </Typography>

                <Button onClick={handleOpenModalHistoryCommand} icon={<HistoryOutlined />} size="large" iconPosition={"end"}
                    style={{ marginTop: "10%", marginBottom: "auto", marginLeft: "38%", marginRight: "25%", background: "#008000", color: "white" }} >Histórico de Comandos
                </Button>

            </Modal>

            <Modal
                showBackArrow
                open={openModalHistoryCommands}
                onClose={handleClosedModalHistoryCommand}
                height={750}
                width={"80%"}
                title={"Histórico de Comandos para Módulo"}
            >

                <div style={{ paddingTop: '20px', height: 600, width: '100%' }}>
                    <DataGrid
                        rows={sortedArray}
                        columns={columnsHistoryCommands}
                        pageSize={10}
                        rowsPerPageOptions={[10]}
                    />
                </div>
            </Modal >

            <Modal
                showBackArrow
                open={openBroadcastCommands}
                onClose={() => setOpenBroadcastCommands(false)}
                height={"70%"}
                width={"80%"}
                title={"Broadcast de Comandos"}
            >
                <div style={{ display: 'flex', height: '100%', flexDirection: 'column', justifyContent: 'space-between', flexWrap: 'nowrap' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <TextField
                            label={"Digite o comando para módulos"}
                            value={inputValueBroadcast}
                            onChange={handleInputChangeBroadcast}
                            sx={{ width: '85%' }}
                        />
                        <Button
                            icon={<SendOutlined />}
                            size="large"
                            iconPosition={"end"}
                            style={{ marginLeft: "10px", background: "#008000", color: "white" }}
                            onClick={handleSaveCommandsBroadcast}
                        >
                            Enviar Comando
                        </Button>
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'nowrap', justifyContent: 'center', alignItems: 'center' }}>
                        <Button onClick={handleOpenModalDevicesCommands} icon={<HistoryOutlined />} size="large" iconPosition={"end"}
                            style={{ marginBottom: "auto", float: '', background: "#008000", color: "white" }} >Históricos de Comandos
                        </Button>
                    </div>
                </div>
            </Modal>

            <Modal
                showBackArrow
                open={openModalDevicesCommands}
                onClose={() => setOpenModalDevicesCommands(false)}
                height={"90%"}
                width={"85%"}
                title={"Históricos de Comandos"}
            >

                <div style={{ paddingTop: '20px', height: "100%", width: '100%' }}>
                    <DataGrid
                        rows={sortedHistoryCommands}
                        columns={columnsHistoryCommands}
                        pageSize={10}
                        rowsPerPageOptions={[10]}
                    />
                </div>
            </Modal >
        </>
    );
}